import { endpoints, portalUrls } from '../Config';

export const getPortalUrl = () => portalUrls;

export const getRootEndpoint = (root, { isSandBox = false } = {}) => {
  const { liveURL, sandboxURL } = endpoints;
  const endpointByMode = isSandBox ? sandboxURL : liveURL;
  return endpointByMode[root] || endpointByMode.office_api;
};

export default getRootEndpoint;
